import { useMemo, useCallback } from 'react';
import { useTranslation } from 'next-i18next';
import { Namespaces } from 'types/locales';

export interface UseVirtualTourOptions {
  virtualTourUrl: string | null | undefined;
  onTrack?: () => void;
}

export interface UseVirtualTourResult {
  /** Whether virtual tour is available */
  hasVirtualTour: boolean;
  /** Pre-formatted button label */
  label: string;
  /** URL for the virtual tour */
  url: string;
  /** Click handler with analytics */
  handleClick: () => void;
}

/**
 * Hook for virtual tour button formatting and analytics
 */
export function useVirtualTour({
  virtualTourUrl,
  onTrack,
}: UseVirtualTourOptions): UseVirtualTourResult {
  const { t } = useTranslation(Namespaces.COMMON);

  const label = useMemo(() => 
    t('listing.virtual_tour_button_label', { defaultValue: 'Virtual Tour' }),
    [t]
  );

  const handleClick = useCallback(() => {
    onTrack?.();
  }, [onTrack]);

  return {
    hasVirtualTour: Boolean(virtualTourUrl),
    label,
    url: virtualTourUrl || '',
    handleClick,
  };
}
